import { render, staticRenderFns } from "./suggestionsContainer.vue?vue&type=template&id=0a5910f8&scoped=true&"
import script from "./suggestionsContainer.vue?vue&type=script&lang=js&"
export * from "./suggestionsContainer.vue?vue&type=script&lang=js&"
import style0 from "./suggestionsContainer.vue?vue&type=style&index=0&id=0a5910f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5910f8",
  null
  
)

export default component.exports